import { render, staticRenderFns } from "./childcustomerimage.vue?vue&type=template&id=54f92a71&"
import script from "./childcustomerimage.vue?vue&type=script&lang=js&"
export * from "./childcustomerimage.vue?vue&type=script&lang=js&"
import style0 from "./childcustomerimage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports